import { render } from "./others-settings.vue?vue&type=template&id=5d9d3e7e"
import script from "./others-settings.vue?vue&type=script&lang=js"
export * from "./others-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__